import COLORS from '@zeus/core/colors';
import { EActivity } from '_/common/activityType/activityType.types';

export const MAX_INPUTS_PERFORMANCE_THRESHOLD = 1e5;

export const SNAPSHOT_ACTIVITY_OPTIONS: EActivity[] = [EActivity.COMMENTS, EActivity.TRANSITIONS];

export const SnapshotStatus = {
  PENDING_QUEUE: 'PENDING_QUEUE',
  PENDING_IMPORT: 'PENDING_IMPORT',
  IMPORTING: 'IMPORTING',
  ANALYZING: 'ANALYZING',
  FAILED: 'FAILED',
  PENDING_QA: 'PENDING_QA',
  QA: 'QA',
  FIXING: 'FIXING',
  ESCALATED: 'ESCALATED',
  PASSED_QA: 'PASSED_QA',
  FAILED_QA: 'FAILED_QA',
  PUBLISHED: 'PUBLISHED',
  PUSHED: 'PUSHED',
  PUSHED_IGNORE: 'PUSHED_IGNORE',
  SUPERCEDED: 'SUPERCEDED',
  DRAFT_SCHEMA: 'DRAFT_SCHEMA',
  SCHEDULED: 'SCHEDULED',
  START_QUEUED: 'START_QUEUED',
  START_SCHEDULED: 'START_SCHEDULED',
  START_PENDING: 'START_PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  NO_LOGIN_AVAILABLE: 'NO_LOGIN_AVAILABLE',
  START_FAILED: 'START_FAILED',
  INTERNAL_FAILURE: 'INTERNAL_FAILURE',
  CHUNKED: 'CHUNKED',
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
  CANCEL_PENDING: 'CANCEL_PENDING',
  CANCEL_QUEUED: 'CANCEL_QUEUED',
  CANCELLED: 'CANCELLED',
  COLLATING: 'COLLATING',
  COLLECTION_WINDOW_CLOSED: 'COLLECTION_WINDOW_CLOSED',
  TIMED_OUT: 'TIMED_OUT',
  CHUNKED_PUSHED: 'CHUNKED_PUSHED',
  COMPLETED: 'COMPLETED',
  POST_PROCESSING: 'POST_PROCESSING',
  GENERATING_ASSETS: 'GENERATING_ASSETS',
};

export const CRAWL_RUN_SNAPSHOT_STATUSES = [
  SnapshotStatus.CANCELLED,
  SnapshotStatus.CANCEL_PENDING,
  SnapshotStatus.CANCEL_QUEUED,
  SnapshotStatus.CANCEL_REQUESTED,
  SnapshotStatus.COLLECTION_WINDOW_CLOSED,
  SnapshotStatus.COLLATING,
  SnapshotStatus.IN_PROGRESS,
  SnapshotStatus.SCHEDULED,
  SnapshotStatus.START_PENDING,
  SnapshotStatus.START_QUEUED,
  SnapshotStatus.START_SCHEDULED,
  SnapshotStatus.TIMED_OUT,
];

// Crawl run statuses where the run is still active (excludes terminal CANCELLED, COLLECTION_WINDOW_CLOSED, TIMED_OUT)
export const CRAWL_RUN_ACTIVE_STATUSES = CRAWL_RUN_SNAPSHOT_STATUSES.filter(
  (status) => ![SnapshotStatus.CANCELLED, SnapshotStatus.COLLECTION_WINDOW_CLOSED, SnapshotStatus.TIMED_OUT].includes(status),
);

export const CRAWL_RUN_FAILURE_STATUSES = [SnapshotStatus.NO_LOGIN_AVAILABLE, SnapshotStatus.START_FAILED];

export const IMPORT_IN_PROGRESS_SNAPSHOT_STATUSES = [
  SnapshotStatus.ANALYZING,
  SnapshotStatus.IMPORTING,
  SnapshotStatus.GENERATING_ASSETS,
  SnapshotStatus.PENDING_IMPORT,
  SnapshotStatus.PENDING_QUEUE,
];

export const IMPORT_FAILURE_STATUSES = [SnapshotStatus.INTERNAL_FAILURE, SnapshotStatus.FAILED];

export const SNAPSHOT_PUSHED_STATUSES = [SnapshotStatus.PUSHED, SnapshotStatus.PUSHED_IGNORE];

export const USER_OWNED_SNAPSHOT_STATUSES = [
  SnapshotStatus.PENDING_QA,
  SnapshotStatus.QA,
  SnapshotStatus.FIXING,
  SnapshotStatus.ESCALATED,
  SnapshotStatus.FAILED_QA,
];

export const CANCELLABLE_SNAPSHOT_STATUSES = [SnapshotStatus.IN_PROGRESS, SnapshotStatus.START_SCHEDULED, SnapshotStatus.CHUNKED];

export const SNAPSHOT_STATUS_COLOR_MAPPING = {
  [SnapshotStatus.PENDING_QUEUE]: COLORS.PURPLE,
  [SnapshotStatus.PENDING_IMPORT]: COLORS.PURPLE,
  [SnapshotStatus.IMPORTING]: COLORS.PURPLE,
  [SnapshotStatus.ANALYZING]: COLORS.PURPLE,
  [SnapshotStatus.FAILED]: COLORS.RED,
  [SnapshotStatus.PENDING_QA]: COLORS.ORANGE,
  [SnapshotStatus.QA]: COLORS.YELLOW,
  [SnapshotStatus.FIXING]: COLORS.YELLOW,
  [SnapshotStatus.ESCALATED]: COLORS.RED,
  [SnapshotStatus.PASSED_QA]: COLORS.GREEN,
  [SnapshotStatus.FAILED_QA]: COLORS.DARKER_RED,
  [SnapshotStatus.PUBLISHED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.PUSHED]: COLORS.GREEN,
  [SnapshotStatus.PUSHED_IGNORE]: COLORS.GREEN,
  [SnapshotStatus.SUPERCEDED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.DRAFT_SCHEMA]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.SCHEDULED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.START_QUEUED]: COLORS.PURPLE,
  [SnapshotStatus.START_SCHEDULED]: COLORS.PURPLE,
  [SnapshotStatus.START_PENDING]: COLORS.PURPLE,
  [SnapshotStatus.IN_PROGRESS]: COLORS.PURPLE,
  [SnapshotStatus.NO_LOGIN_AVAILABLE]: COLORS.RED,
  [SnapshotStatus.START_FAILED]: COLORS.RED,
  [SnapshotStatus.INTERNAL_FAILURE]: COLORS.RED,
  [SnapshotStatus.CHUNKED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.CANCEL_REQUESTED]: COLORS.PURPLE,
  [SnapshotStatus.CANCEL_QUEUED]: COLORS.PURPLE,
  [SnapshotStatus.CANCELLED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.CANCEL_PENDING]: COLORS.PURPLE,
  [SnapshotStatus.COLLATING]: COLORS.PURPLE,
  [SnapshotStatus.COLLECTION_WINDOW_CLOSED]: COLORS.PURPLE,
  [SnapshotStatus.TIMED_OUT]: COLORS.PURPLE,
  [SnapshotStatus.CHUNKED_PUSHED]: COLORS.MEDIUM_GREY,
  [SnapshotStatus.COMPLETED]: COLORS.GREEN,
  [SnapshotStatus.POST_PROCESSING]: COLORS.PURPLE,
  [SnapshotStatus.GENERATING_ASSETS]: COLORS.PURPLE,
};
